import { datadogRum } from '@datadog/browser-rum';
import { MelwaysProvider } from '@seek/melways-react';
import setDebug from 'debug';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App/App';
import { getEnvironment, getVersion } from './config';
import type { ClientContext } from './render';
import { setAccountId, setSeekId } from './utils/account-selection';
import { isCypressTest } from './utils/cypress';
import { isLocalDev, isProd } from './utils/environment';

if (isLocalDev()) {
  if (!isCypressTest()) {
    if (Boolean(process.env.SEEK_ID)) {
      setSeekId(process.env.SEEK_ID as string); // seekId for seek account
    } else {
      // eslint-disable-next-line no-console
      console.error('Please add SEEK_ID into .env file');
    }
    setAccountId(3); // advertiserId for seek account
  }
  setDebug.enable('*,-sockjs*,-cypress*,-engine*,-socket*');
}

if (isProd()) {
  datadogRum.init({
    applicationId: '8e8a4abe-9ee0-4627-b366-5fbda2ace68b',
    clientToken: 'pub48f2d4a083d62955079c8d680c9e5582',
    site: 'datadoghq.com',
    service: 'adv-branding-ui',
    env: getEnvironment(),
    version: getVersion(),
    sessionSampleRate: 20,
    sessionReplaySampleRate: 0,
    trackUserInteractions: false,
    trackResources: true,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
}

export default ({ locale, site, environment }: ClientContext) => {
  hydrate(
    <MelwaysProvider.Client site={site} staging={environment !== 'production'}>
      <BrowserRouter>
        <App locale={locale} site={site} environment={environment} />
      </BrowserRouter>
    </MelwaysProvider.Client>,
    document.getElementById('root'),
  );
};
